// Project tools already provide relative paths. Keep those paths local to the
// task's folder; native inspectFile applies the filesystem access checks.
export function projectSourcePath(value) {
  if (typeof value !== 'string' || value.length > 1024) return null;
  const path = value.replace(/^\.\//, '');
  if (!path || /[\x00-\x1f\x7f\\:*?#<>]/.test(path) || path.startsWith('/') || path.startsWith('~') ||
      path.split('/').some(part => !part || part === '.' || part === '..')) return null;
  return path;
}
